import { getTestId } from '@airtel/air-design-system';
export var defaultProps = Object.assign({
  data: [{
    id: '1',
    imageProps: {
      uri: 'https://assets.airtel.in/static-assets/airtel-pay-sdk/checkout/xhdpi/airtel_upi.png',
      height: 16,
      width: 120
    },
    shouldCollapse: false,
    isExpanded: true,
    content: {
      offerListWidget: {
        data: [{
          selectionListProps: {
            variation: 'full-size',
            id: '1',
            style: {
              backgroundColor: '#f4f5ff'
            },
            buttonProps: {
              buttonType: 'primary',
              size: 'md',
              theme: 'light',
              title: 'pay ₹2,299',
              controlState: 'none'
            },
            isSelected: false,
            linkListItemProps: {
              actionType: 'radio',
              roundedCorners: true,
              noPadding: true,
              heading: 'Paytm',
              style: {
                backgroundColor: '#f4f5ff',
                paddingHorizontal: 16,
                paddingTop: 8
              },
              avatarImgUrl: 'https://assets.airtel.in/static-assets/airtel-pay-sdk/upi-apps/xxhdpi/paytm_b.png'
            }
          }
        }, {
          selectionListProps: {
            variation: 'full-size',
            id: '2',
            style: {
              backgroundColor: '#f4f5ff'
            },
            buttonProps: {
              buttonType: 'primary',
              size: 'md',
              theme: 'light',
              title: 'pay ₹2,299',
              controlState: 'none'
            },
            isSelected: false,
            linkListItemProps: {
              actionType: 'radio',
              roundedCorners: true,
              noPadding: true,
              heading: 'Paytm',
              style: {
                backgroundColor: '#f4f5ff',
                paddingHorizontal: 16,
                paddingTop: 8
              },
              avatarImgUrl: 'https://assets.airtel.in/static-assets/airtel-pay-sdk/upi-apps/xxhdpi/paytm_b.png'
            }
          }
        }, {
          cardTitleProps: {
            onPressMetaData: {
              id: 'card title press'
            },
            color: 'black',
            iconName: 'CategoriesIcon',
            actionIconName: 'RightChevronIcon',
            title: 'select other payment options',
            showActionCtaWithCheveron: true,
            actionTypes: 'icon'
          }
        }]
      }
    }
  }, {
    id: '2',
    title: 'CREDIT/DEBIT/ATM CARD',
    iconName: 'PayFilledIcon',
    shouldCollapse: true,
    isExpanded: false,
    content: {
      payCategoryCardWidget: {
        primaryCallout: {
          title: 'Title goes here',
          description: 'Descriptor goes here',
          showCrossDismissBtn: true,
          iconName: 'BillIcon',
          state: 'lilac'
        },
        secondaryCallout: {
          description: 'offer available on ICICI cards. you can choose to proceed without offer',
          showCrossDismissBtn: true,
          iconName: 'BillIcon',
          state: 'warning'
        },
        cardNumberInputProps: {
          placeholder: 'card number',
          maxLength: 23,
          keyboardType: 'numeric'
        },
        cardNameInputProps: {
          placeholder: 'name on card'
        },
        cardDateInputProps: {
          placeholder: 'valid thru (mm/yy)',
          maxLength: 5,
          keyboardType: 'numeric'
        },
        cardCVVInputProps: {
          placeholder: 'CVV',
          hintText: 'What is',
          hintActionText: 'CVV?',
          maxLength: 3,
          showAppend: true,
          appendItems: {
            prefixIcon: {
              iconName: 'HideButtonIcon',
              isActionable: true
            },
            isPressable: true
          }
        },
        buttonProps: {
          direction: 'column',
          leftCta: {
            title: 'Pay ₹2,299',
            version: 'variable-width',
            buttonType: 'primary'
          },
          rightCta: {
            title: 'Additional Tertiary Button',
            version: 'variable-width',
            buttonType: 'tertiary'
          }
        },
        isChecked: true,
        showTrustMarker: true,
        trustMarkerCtaTitle: 'KNOW MORE',
        trustMarkerTitle: 'Your card will be securely saved for faster payments. CVV number will not be saved.',
        trustMarkerCtaOnPressMetaData: {
          actions: [{}]
        },
        minCardNumberLength: 17
      }
    }
  }, {
    id: '3',
    title: 'Saved',
    iconName: 'StarButtonIcon',
    shouldCollapse: true,
    isExpanded: true,
    content: {
      offerListWidget: {
        data: [{
          selectionListProps: {
            variation: 'full-size',
            id: '1',
            style: {
              backgroundColor: '#f4f5ff'
            },
            buttonProps: {
              buttonType: 'primary',
              size: 'md',
              theme: 'light',
              title: 'pay ₹2,299',
              controlState: 'none'
            },
            isSelected: false,
            linkListItemProps: {
              actionType: 'radio',
              roundedCorners: true,
              noPadding: true,
              heading: 'Paytm',
              style: {
                backgroundColor: '#f4f5ff',
                paddingHorizontal: 16,
                paddingTop: 8
              },
              avatarImgUrl: 'https://assets.airtel.in/static-assets/airtel-pay-sdk/upi-apps/xxhdpi/paytm_b.png'
            }
          }
        }, {
          selectionListProps: {
            variation: 'full-size',
            id: '2',
            style: {
              backgroundColor: '#f4f5ff'
            },
            buttonProps: {
              buttonType: 'primary',
              size: 'md',
              theme: 'light',
              title: 'pay ₹2,299',
              controlState: 'none'
            },
            isSelected: false,
            linkListItemProps: {
              actionType: 'radio',
              roundedCorners: true,
              noPadding: true,
              heading: 'Paytm',
              style: {
                backgroundColor: '#f4f5ff',
                paddingHorizontal: 16,
                paddingTop: 8
              },
              avatarImgUrl: 'https://assets.airtel.in/static-assets/airtel-pay-sdk/upi-apps/xxhdpi/paytm_b.png'
            }
          }
        }, {
          cardTitleProps: {
            onPressMetaData: {
              id: 'card title press'
            },
            color: 'black',
            iconName: 'CategoriesIcon',
            actionIconName: 'RightChevronIcon',
            title: 'select other payment options',
            showActionCtaWithCheveron: true,
            actionTypes: 'icon'
          }
        }]
      }
    }
  }, {
    id: '4',
    title: 'Recommended',
    iconName: 'ActivateIcon',
    shouldCollapse: true,
    isExpanded: true,
    content: {
      offerListWidget: {
        data: [{
          selectionListProps: {
            variation: 'full-size',
            id: '1',
            style: {
              backgroundColor: '#f4f5ff'
            },
            buttonProps: {
              buttonType: 'primary',
              size: 'md',
              theme: 'light',
              title: 'pay ₹2,299',
              controlState: 'none'
            },
            isSelected: false,
            linkListItemProps: {
              actionType: 'radio',
              roundedCorners: true,
              noPadding: true,
              heading: 'Paytm',
              style: {
                backgroundColor: '#f4f5ff',
                paddingHorizontal: 16,
                paddingTop: 8
              },
              avatarImgUrl: 'https://assets.airtel.in/static-assets/airtel-pay-sdk/upi-apps/xxhdpi/paytm_b.png'
            }
          }
        }, {
          selectionListProps: {
            variation: 'full-size',
            id: '2',
            style: {
              backgroundColor: '#f4f5ff'
            },
            buttonProps: {
              buttonType: 'primary',
              size: 'md',
              theme: 'light',
              title: 'pay ₹2,299',
              controlState: 'none'
            },
            isSelected: false,
            linkListItemProps: {
              actionType: 'radio',
              roundedCorners: true,
              noPadding: true,
              heading: 'Paytm',
              style: {
                backgroundColor: '#f4f5ff',
                paddingHorizontal: 16,
                paddingTop: 8
              },
              avatarImgUrl: 'https://assets.airtel.in/static-assets/airtel-pay-sdk/upi-apps/xxhdpi/paytm_b.png'
            }
          }
        }, {
          cardTitleProps: {
            onPressMetaData: {
              id: 'card title press'
            },
            color: 'black',
            iconName: 'CategoriesIcon',
            actionIconName: 'RightChevronIcon',
            title: 'select other payment options',
            showActionCtaWithCheveron: true,
            actionTypes: 'icon'
          }
        }]
      }
    }
  }, {
    id: '5',
    title: 'Recommended',
    iconName: 'ActivateIcon',
    shouldCollapse: true,
    isExpanded: true,
    content: {
      offerListWidget: {
        data: [{
          selectionListProps: {
            variation: 'full-size',
            id: '1',
            style: {
              backgroundColor: '#f4f5ff'
            },
            buttonProps: {
              buttonType: 'primary',
              size: 'md',
              theme: 'light',
              title: 'pay ₹2,299',
              controlState: 'none'
            },
            isSelected: false,
            linkListItemProps: {
              actionType: 'radio',
              roundedCorners: true,
              noPadding: true,
              heading: 'Paytm',
              style: {
                backgroundColor: '#f4f5ff',
                paddingHorizontal: 16,
                paddingTop: 8
              },
              avatarImgUrl: 'https://assets.airtel.in/static-assets/airtel-pay-sdk/upi-apps/xxhdpi/paytm_b.png'
            }
          }
        }, {
          selectionListProps: {
            variation: 'full-size',
            id: '2',
            style: {
              backgroundColor: '#f4f5ff'
            },
            buttonProps: {
              buttonType: 'primary',
              size: 'md',
              theme: 'light',
              title: 'pay ₹2,299',
              controlState: 'none'
            },
            isSelected: false,
            linkListItemProps: {
              actionType: 'radio',
              roundedCorners: true,
              noPadding: true,
              heading: 'Paytm',
              style: {
                backgroundColor: '#f4f5ff',
                paddingHorizontal: 16,
                paddingTop: 8
              },
              avatarImgUrl: 'https://assets.airtel.in/static-assets/airtel-pay-sdk/upi-apps/xxhdpi/paytm_b.png'
            }
          }
        }, {
          cardTitleProps: {
            onPressMetaData: {
              id: 'card title press'
            },
            color: 'black',
            iconName: 'CategoriesIcon',
            actionIconName: 'RightChevronIcon',
            title: 'select other payment options',
            showActionCtaWithCheveron: true,
            actionTypes: 'icon'
          }
        }]
      }
    }
  }],
  maxItemsToShow: 3,
  viewMoreButtonProps: {
    title: 'view other payment options ',
    iconName: 'DownChevronIcon',
    expandedTitle: 'hide other payment options ',
    expandedIconName: 'UpChevronIcon',
    isUpperCase: true
  }
}, getTestId('CollapsibleOfferListWidgetContainer'));